import React from 'react';
import {
  useStatefullyAwareInScopeModel,
  useWatchableValue,
} from '@cotera/client/v0/actions/framework';
import { Switch } from '@cotera/client/v0/components/ui/switch';
import { AppModel } from '../shell/app.model';

export const DisplaySettingsView: React.FC = () => {
  const appModel = useStatefullyAwareInScopeModel(AppModel);

  if (appModel === null) {
    return (
      <div className="text-sm text-muted-foreground">
        Display preferences are not available in this view.
      </div>
    );
  }

  return <DisplaySettingsViewInner appModel={appModel} />;
};

const DisplaySettingsViewInner: React.FC<{ appModel: AppModel }> = ({
  appModel,
}) => {
  const preferences = useWatchableValue(appModel.uiPreferences);

  const setShowCredits = (next: boolean) => {
    appModel.uiPreferences.set({ ...preferences, showCredits: next });
  };

  return (
    <div className="space-y-6">
      <section className="space-y-3">
        <h3 className="text-sm font-medium">Display</h3>
        <div className="flex items-center justify-between rounded-lg border border-border bg-white px-3 py-2.5">
          <div className="flex flex-col">
            <label
              htmlFor="show-credits-toggle"
              className="text-sm font-medium text-foreground"
            >
              View credits
            </label>
            <span className="text-xs text-muted-foreground">
              Show credit balance and chat cost in the UI.
            </span>
          </div>
          <Switch
            id="show-credits-toggle"
            checked={preferences.showCredits}
            onCheckedChange={setShowCredits}
          />
        </div>
      </section>
    </div>
  );
};
